import { alpha } from '@mui/material/styles';
import { PieChartBlock } from '../../viz.types';

export interface PieChartSlice {
  name: string;
  value: number;
  fill: string;
  share: number | null;
}

export interface PieChartData {
  slices: PieChartSlice[];
  total: number;
}

export interface GetPieChartSlicesParams {
  slices: PieChartBlock['slices'];
  sliceColors: string[];
  sliceOpacities: number[];
}

export interface GetSliceFillParams {
  index: number;
  colors: string[];
  opacities: number[];
}

export const getSliceFill = ({ index, colors, opacities }: GetSliceFillParams) => {
  const color = colors[index % colors.length];
  const cycle = Math.floor(index / colors.length);
  const opacity = opacities[Math.min(cycle, opacities.length - 1)];

  return opacity === 1 ? color : alpha(color, opacity);
};

export const getPieChartSlices = ({
  slices,
  sliceColors,
  sliceOpacities,
}: GetPieChartSlicesParams): PieChartData => {
  const total = slices.reduce((sum, slice) => sum + slice.value, 0);

  return {
    total,
    slices: slices.map((slice, index) => ({
      name: slice.label,
      value: slice.value,
      fill: getSliceFill({ index, colors: sliceColors, opacities: sliceOpacities }),
      share: total > 0 ? slice.value / total : null,
    })),
  };
};
